<template>
  <section class="homeProduct">
    <div class="productBoxBg">
      <div class="item first"
           :class="active==0&&'active'"><span>笔记本</span></div>
      <div class="item"
           v-for="(item,index) in brands"
           :key="index"
           :class="active==item.id&&'active'"><span v-if="index<5"
              @click="onBrand(item.id)">{{item.name}}</span></div>
    </div>
    <div class="productBox">
      <swiper :options="swiperOption"
              ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="item in products"
                      :key="item.id">
          <div class="item">
            <router-link :to="{name: 'Product', params: { id: item.id }}">
              <span class="tip">环保补助奖金{{item.bonus_price}}元</span>
              <div class="image"
                   :style="'background:url('+item.img+') no-repeat;background-size:100%; '"></div>
              <div class="title">{{item.title}}</div>
              <div class="price">
                新机价格
                <span>¥{{item.price}}</span>
              </div>
            </router-link>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev"
             slot="button-prev"></div>
        <div class="swiper-button-next"
             slot="button-next"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["products", "brands"],
  data () {
    return {
      active: 0,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        spaceBetween: 40,
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: true,
        loopFillGroupWithBlank: true,
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    onBrand (id) {
      // this.active = id
      // let data = {
      //   LaptopId: id
      // }
      // this.$emit("onBrandId", data);
      this.$store.commit('product/setCatId', 30);
      this.$store.commit('product/setBrandId', id);
      this.$router.push({ path: "/list" });
    }
  },
  mounted () {
  }
};
</script>

<style scoped>
.homeProduct {
  margin: 50px auto 40px;
}
.productTitleBg {
  margin: 20px auto 40px;
  text-align: center;
  font-size: 42px;
}
.productBoxBg {
  display: flex;
  width: 1226px;
  height: 78px;
  line-height: 78px;
  background: #fff;
  margin-top: 90px;
  border-bottom: solid #fad07c 3px;
  position: relative;
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  width: 40px;
}
.swiper-button-prev {
  left: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAgVBMVEUAAAD1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr0RF/14uf0S2X1wcr1vcj1u8b0lqb0h5n11dz10dj1qbb1s7/0X3b0Vm70UGn17PD1n630cIX0aoB+x4Y4AAAAF3RSTlMA+gSY7OOsh3hYNxwT09KxCu2V7rO2tA14TwcAAAEoSURBVDjLpZVbcsIwDEVlxy8cA0mgtQlNmxboa/8L7E+nii2ZDsP5Sjx3dCVFViBDemc2vRD9xjgvoUZrdVygbcvKwiBigRgC1a1UZFCrQiabWKHJUu32scq+W8TbxitsMSb68u5/dUSGzzM+/1YUuHqf0wVf+lA1fknvxLwVXLzxkHW+BQBLdW/pcshPLIDUjO+5PNISPKMbP8ihB0d9MT/EgSF1fKMOMbCmfeFYg6J94VAg8vy+eF0UuXBMT7EizK1fU02pimKmlI58MWV7jhWlIQ2feXdHPyGfp2eG4sS4a4ljlsWciiPLD+6MysXgwhAJU5FnQy8Xdum06HaoX9d5TOS6/r8Abl8p0D3UdY/d7Wvv+iIlhIau5ibcsezx97ETYkd/Hz8UPm/iKRzjXQAAAABJRU5ErkJggg==)
    no-repeat;
}
.swiper-button-next {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAmVBMVEUAAAD1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr1+Pr0RF/0cIX0hpj0aH717PD16e312N/0m6r0gZT0Ynn0Vm/0UGr0S2X18PP14+f1rLj1o7H0laX0j5/0eo70dov0XHT19fj0jZ66mU2+AAAAGnRSTlMA7fqW06w3EwUC45iHHFm0sXl4Clf45IgemcEBEjsAAAFDSURBVDjLnZXbUoNADECzsEuBAi30alKq1d7U3vT/P84HHcNmd+noecycISQkASyypDFazWZKmybJIERZ5NghL0qvNogjFETxwPWmCj2oqdDSGAPEadebjDDIaNJ53hh7GPMzh9jL8LcOjrXrJ49Z/fSlU++J9q+e2r+7ZBX8zqZMvrT7/EyHR0eMlgBQiGBLW/c9C4Asl8E3OmxkLM8gQYcTkZM9gRpdznQ7ilADBplO9p3IbkALJ1C7BoUBc2fVrkBOK3d+Z3WSRcmebFEFvBVd7dQ65F1EMcbrrelFtqfu85jG9wk/XA8THgpmRSt3KNwxO27p0zdmUIpO3qh1B7d0VgGvnJeJneXabOkcXC6oOHShNriu9w/Aw59Pyv0jxaTB7MMUbCr/Ia3+cZqZcjHvavNFCSGypDZaRZHSpha/jy8YtH9LEJSHcgAAAABJRU5ErkJggg==)
    no-repeat;
  right: 0;
}
.productBoxBg .item {
  width: 300px;
  text-align: center;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.productBoxBg .first {
  width: 394px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.productBoxBg .active {
  background: rgba(250, 208, 124, 1);
}
.productBox .item {
  background: #fff;
  width: 276px;
  height: 318px;
  text-align: center;
  margin: 20px 40px 0 0;
  position: relative;
  padding-top: 20px;
  box-shadow: 0px 0px 10px 0px rgba(186, 183, 183, 0.2);
}
.productBox .item .tip {
  background: #fc5b74;
  color: #fff;
  border-bottom-left-radius: 20px;
  padding: 5px 20px;
  position: absolute;
  right: 0;
  top: 0;
}
.productBox .item .more {
  position: absolute;
  right: 20px;
  top: 10px;
}
.productBox .item:hover {
  background: #fff;
  box-shadow: #efefef 0 0 5px;
}
.productBox .item:nth-child(4n) {
  margin-right: 0;
}
.productBox .item .image {
  width: 137px;
  height: 137px;
  background-size: 200px;
  margin: 50px auto 20px;
}
.productBox .item .title {
  font-size: 16px;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0px 0 20px;
}
.productBox .item .price {
  margin: 20px 0;
}
.productBox .item .price span {
  color: #d81e06;
  font-weight: bold;
}
.productBox .item .btn {
  background: #fad07c;
  width: 180px;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 50px;
}
.productBox .item a .btn {
  color: #333;
}
.moreproduct {
  text-align: center;
  margin: 30px 0;
}
.moreproduct a {
  color: #e8bb60;
  font-size: 20px;
}
</style>
